<template>
    <div style="position: fixed; left: 50%; top: 50%; tranform: translate(-50%, -50%);">{{$t('noPermission.txt1')}}</div>
</template>


<script>
export default {
    
}
</script>